import toast from "react-hot-toast";

const httpAction = async (data) => {

  try {
    const response = await fetch(data.url, {
      method: data.method || "GET",
      body: data.formData
        ? data.formData
        : data.body
          ? JSON.stringify(data.body)
          : null,
      headers: data.formData
        ? undefined
        : { "Content-Type": "application/json" },
    });
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result?.message);
    }
    return result;
  } catch (error) {
   toast.error(error.message)
  }
};

export default httpAction;
